import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers/';
import { getFiscalYear } from 'Common/GeneralHelper';
import { createToast, toastType } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { ReportFieldEnum } from 'Common/FieldEnum';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';
import { EXTENDED_BENEFITS_FORM_NAME } from 'Common/FormEnum';

import { ExtendedBenefitsForm } from './components/ExtendedBenefitsForm';
import * as actions from './state/report/actions';

class ExtendedBenefitsReportContainer extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { report, error, excelReport } = this.props;

    if (error) {
      createToast(toastType.error, 'Error', 'Error retrieving report!', true);
    } else {
      if (prevProps.report !== report && report !== null) {
        if (!report) {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
        if (report) {
          ReportGeneration(report, 'Extended Benefits Report');
        }
      }
      if (prevProps.excelReport !== excelReport && excelReport !== null) {
        if (!excelReport) {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      }
    }
    this.props.clearReport();
  }

  getMainProps = () => {
    return {
      toolbox: {
        formName: EXTENDED_BENEFITS_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: this.props.loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = formValues => {
    const {
      getExtendedBenefitsExcelReport,
      getExtendedBenefitsReport,
    } = this.props;

    if (formValues.ReportFormat === reportFormatEnum.Excel) {
      getExtendedBenefitsExcelReport(formValues);
    } else {
      getExtendedBenefitsReport(formValues);
    }
  };

  getFiscalYearString = () => {
    return (
      (getFiscalYear(new Date()) - 1).toString() +
      ' - ' +
      getFiscalYear(new Date()).toString()
    );
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? (
          <LoadingPage
            message={
              this.props.loading && this.props.reportLoading
                ? 'Loading Report'
                : 'Loading'
            }
          />
        ) : (
          undefined
        )}
        <Filter title={'Extended Benefits Report'} />
        <Main {...this.getMainProps()}>
          <ExtendedBenefitsForm
            onSubmit={this.handleSubmit}
            getFiscalYearString={this.getFiscalYearString}
            initialValues={{
              [ReportFieldEnum.ReportFormat]: reportFormatEnum.PDF,
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    loading,
    report,
    error,
    reportLoading,
    excelReport,
  } = state.ExtendedBenefitsState.report;

  return {
    report: report,
    loading: loading,
    reportLoading: reportLoading,
    error: error,
    excelReport: excelReport,
  };
};

export const ExtendedBenefits = withRouter(
  connect(mapStateToProps, actions)(ExtendedBenefitsReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/extendedbenefits/ExtendedBenefits.js